import { dashboardService } from '../../../../services/dashboard.service';
import type { PromptApi } from '../../../../services/dashboard.service';
import { proposalPromptApi } from '../../../../services/proposal.service';

/** Which AI the settings page manages. */
export type AiSettingsKind = 'project' | 'proposal';

export const promptApi = (kind: AiSettingsKind): PromptApi =>
  kind === 'proposal' ? proposalPromptApi : dashboardService;
